const OrderUtil = {
  fmtDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);

  const M = String(d.getMonth() + 1).padStart(2, "0");
  const D = String(d.getDate()).padStart(2, "0");
  const Y = d.getFullYear();

  const h = String(d.getHours()).padStart(2, "0");
  const m = String(d.getMinutes()).padStart(2, "0");

  return `${M}/${D}/${Y} ${h}:${m}`;
},


  fmtMoney(n, currency = "USD") {
    if (n == null || n === "") return "";
    const v = Number(n);
    if (Number.isNaN(v)) return String(n);
    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: (currency || "USD").toUpperCase(),
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(v);
    } catch {
      return `${v.toFixed(2)} ${currency || "USD"}`;
    }
  },

  sumLineItemWeight(order) {
    const items = order?.lineItems || order?.items || [];
    return items.reduce((acc, li) => {
      const w =
        li?.weightTotal ?? li?.itemWeight?.totalWeight ?? li?.totalWeight ?? 0;
      return acc + (Number(w) || 0);
    }, 0);
  },

  sumLineItemVolume(order) {
    const items = order?.lineItems || order?.items || [];
    return items.reduce((acc, li) => {
      const w =
        li?.volumeTotal ?? 0;
      return acc + (Number(w) || 0);
    }, 0);
  },

  sumPallets(order) {
    const items = order?.lineItems || order?.items || [];
    const isPalletLike = (t = "") =>
      [
        "PL",
        "PLT",
        "PLTS",
        "PALLET",
        "PALLETS",
        "PALLETS",
        "PALLETS",
        "PALLETS",
      ].slice(0, 6) && // noop (keeps list compact); remove if you like
      ["PL", "PLT", "PLTS", "PALLET", "PALLETS", "PALLETS"].includes(
        t.trim().toUpperCase()
      );

    return items.reduce((acc, li) => {
      const qs =
        li?.quantities ||
        li?.itemQuantities ||
        (Array.isArray(li?.itemQuantity) ? li.itemQuantity : []) ||
        (Array.isArray(li?.ItemQuantity) ? li.ItemQuantity : []);
      if (!qs) return acc;

      const add = qs.reduce((inner, q) => {
        const t = q?.containerType ?? q?.ContainerType;
        const qty = q?.quantity ?? q?.Quantity ?? 0;
        return inner + (isPalletLike(t) ? Number(qty) || 0 : 0);
      }, 0);

      return acc + add;
    }, 0);
  },

  fmtDateTime24(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    // US mm/dd/yyyy hh:mm (24h or 12h—pick your style)
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      // hour: "2-digit",
      // minute: "2-digit",
      // hour12: false,
    }).format(d);
  },

  fmtDateTime12(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(d);
  },
};

export default OrderUtil;
